import { InjectionKey, Ref } from "vue";
import { LMap } from "@vue-leaflet/vue-leaflet";

export const MYMAP_KEY: InjectionKey<Ref<InstanceType<typeof LMap>>> =
  Symbol("mymap");
